module.exports = __webpack_public_path__ + "img/album09_06.72a41507.jpg";